import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material"
import { AccountCircleOutlined, NotificationsNoneOutlined, ChatOutlined, Apps } from "@mui/icons-material"
import { BottomBarDrawer } from "./BottomBarDrawer"

const navigationItems = [
    { icon: <AccountCircleOutlined sx={{ fontSize: 40 }} />, path: "/driver" },
    { icon: <NotificationsNoneOutlined sx={{ fontSize: 40 }} />, path: "/notifications" },
    { icon: <ChatOutlined sx={{ fontSize: 40 }} />, path: "/conversations" },
]

export default function BottomBar() {
    const location = useLocation()
    const navigate = useNavigate()
    const [value, setValue] = useState<number | false>(false)
    const [drawerOpen, setDrawerOpen] = useState(false)

    // Set active tab based on current route
    useEffect(() => {
        const activeIndex = navigationItems.findIndex((item) => item.path === location.pathname)
        setValue(activeIndex !== -1 ? activeIndex : false)
    }, [location.pathname])

    const handleNavigation = (index: number, path?: string) => {
        setValue(index)
        if (path) navigate(path)
    }
    const handleCloseDrawer = () => {
        setDrawerOpen(false)
        setValue(false)
    }

    return (
        <>
            <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation value={value} sx={{ backgroundColor: "#183a50" }}>
                    {navigationItems.map((item, index) => (
                        <BottomNavigationAction
                            key={index}
                            icon={item.icon}
                            onClick={() => handleNavigation(index, item.path)}
                            sx={{ color: value === index ? "primary.main" : "inherit" }}
                        />
                    ))}
                    <BottomNavigationAction
                        icon={<Apps sx={{ fontSize: 40 }} />}
                        onClick={() => {
                            setValue(navigationItems.length)
                            setDrawerOpen(true)
                        }}
                        sx={{ color: value === navigationItems.length ? "primary.main" : "inherit" }}
                    />
                </BottomNavigation>
            </Paper>

            <BottomBarDrawer open={drawerOpen} onClose={handleCloseDrawer} />
        </>
    )
}
